"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcKeyValidationElements = void 0;
var helpers_1 = require("../../../common/helpers");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_key_validation_constants_1 = require("./bc-key-validation-constants");
var BcKeyValidationElements = (function () {
    function BcKeyValidationElements() {
    }
    BcKeyValidationElements.createInlineAlert = function (style, config) {
        return (0, helpers_1.createElement)({
            element: 'article',
            classList: style.secondary ? ['bc-inline-alert-second-color'] : ['bc-inline-alert'],
            props: { id: config.elementId, role: 'alert' },
            children: [
                (0, helpers_1.createElement)({
                    element: 'section',
                    classList: ['bc-inline-alert-status'],
                    children: [
                        (0, helpers_1.createElement)({
                            element: 'section',
                            classList: ['bc-transaction-status', "bc-transaction-status-".concat(style.type), 'bc-transaction-status-sm'],
                            children: [
                                (0, helpers_1.createElement)({
                                    element: 'em',
                                    classList: ['bc-icon', 'bc-sm'],
                                    innerText: style.type === 'error' ? 'error' : 'idea',
                                }),
                            ],
                        }),
                    ],
                }),
                this._createAlertBody(config),
                this._createAlertCloseButton(),
            ],
        });
    };
    BcKeyValidationElements._createAlertBody = function (config) {
        return (0, helpers_1.createElement)({
            element: 'section',
            classList: ['bc-inline-alert-body'],
            children: [
                (0, helpers_1.createElement)({
                    element: 'section',
                    classList: ['bc-inline-alert-content'],
                    children: [
                        (0, helpers_1.createElement)({
                            element: 'p',
                            classList: ['bc-inline-alert-title'],
                            innerText: config.title,
                        }),
                        (0, helpers_1.createElement)({
                            element: 'p',
                            classList: ['bc-inline-alert-text'],
                            innerText: config.description,
                        }),
                    ],
                }),
            ],
        });
    };
    BcKeyValidationElements._createAlertCloseButton = function () {
        return (0, helpers_1.createElement)({
            element: 'section',
            classList: ['bc-inline-alert-close'],
            children: [
                (0, helpers_1.createElement)({
                    element: 'button',
                    classList: [common_constants_1.BcCommonConstants.BC_ICON_BUTTON_GHOST_CLASS, common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SMALL_CLASS, common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG],
                    props: { type: 'button', 'aria-label': 'Cerrar alerta' },
                    children: [
                        (0, helpers_1.createElement)({
                            element: common_constants_1.BcCommonConstants.I_TAG,
                            classList: ['bc-icon'],
                            props: {
                                'aria-hidden': 'true',
                                'aria-label': 'Cerrar alerta',
                            },
                            innerText: 'error',
                        }),
                    ],
                }),
            ],
        });
    };
    BcKeyValidationElements.createGetCodeLink = function (config) {
        return (0, helpers_1.createElement)({
            element: 'div',
            classList: ["".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-try-container")],
            children: [
                (0, helpers_1.createElement)({
                    element: 'a',
                    classList: ['bc-link', 'link-underline'],
                    props: { target: '_blank', href: '/' },
                    children: [
                        (0, helpers_1.createElement)({
                            element: 'em',
                            classList: ['bc-icon', 'bc-xs'],
                            props: {
                                'aria-hidden': 'true',
                                'aria-label': config.getNewCodeLabel,
                            },
                            innerText: 'sync-refresh',
                        }),
                        (0, helpers_1.createElement)({
                            element: 'u',
                            innerText: config.getNewCodeLabel,
                        }),
                    ],
                }),
            ],
        });
    };
    BcKeyValidationElements.createInputToken = function (config, status, currentAttemp, formatAttempsLabel) {
        return (0, helpers_1.createElement)({
            element: 'div',
            classList: ["".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-input-container")],
            children: [
                (0, helpers_1.createElement)({
                    element: 'div',
                    classList: ["".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-input-content")],
                    children: [
                        (0, helpers_1.createElement)({
                            element: 'div',
                            classList: ['bc-form-field'],
                            children: [
                                (0, helpers_1.createElement)({
                                    element: 'div',
                                    classList: ['bc-input-token'],
                                    props: { status: status },
                                    children: [this._createInputTokenContainer(config, currentAttemp, formatAttempsLabel)],
                                }),
                            ],
                        }),
                    ],
                }),
            ],
        });
    };
    BcKeyValidationElements._createInputTokenContainer = function (config, currentAttemp, formatAttempsLabel) {
        return (0, helpers_1.createElement)({
            element: 'div',
            classList: ['bc-input-token-container'],
            props: {
                'num-inputs': config.numberOfDigits,
                'info-message': formatAttempsLabel(currentAttemp),
                'error-message': formatAttempsLabel(currentAttemp),
            },
        });
    };
    BcKeyValidationElements.createLoading = function (config) {
        var loadingContainer = (0, helpers_1.createElement)({
            element: 'div',
            classList: ["".concat(bc_key_validation_constants_1.BcKeyValidationConstants.MAIN_CLASS, "-content-loading")],
            children: [
                (0, helpers_1.createElement)({
                    element: 'em',
                    classList: ['bc-icon', 'bc-loader', 'bc-loader-xl', 'bc-xl'],
                    innerText: 'spinner',
                }),
                (0, helpers_1.createElement)({
                    element: 'p',
                    classList: ['bc-opensans-font-style-2-regular'],
                    innerText: config.loadingLabel,
                }),
            ],
        });
        var spinnerElement = loadingContainer.children[0];
        spinnerElement.tabIndex = 0;
        spinnerElement === null || spinnerElement === void 0 ? void 0 : spinnerElement.setAttribute("".concat(common_constants_1.BcCommonConstants.ARIA_LABEL), "".concat(bc_key_validation_constants_1.BcKeyValidationConstants.LOADING));
        return loadingContainer;
    };
    BcKeyValidationElements.createIllustration = function (imgPath, classList, arialLabel) {
        return (0, helpers_1.createElement)({
            element: 'div',
            classList: classList,
            children: [
                (0, helpers_1.createElement)({
                    element: 'img',
                    props: {
                        src: imgPath,
                        'aria-label': arialLabel,
                    },
                    classList: ['bc-illustration'],
                }),
            ],
        });
    };
    return BcKeyValidationElements;
}());
exports.BcKeyValidationElements = BcKeyValidationElements;
